import { api } from "@api/api";
import { BookMonth } from "@modules/bookMonths/types";
import { BookMonthFormValues } from "@modules/bookMonths/validations";

export async function createBookMonthService(data: BookMonthFormValues): Promise<BookMonth> {
  const { data: bookMonth } = await api.post<BookMonth>("v2/bookstore/book_month_admin/", data);
  return bookMonth;
}
